import React, { useState } from "react";
import { FiX, FiCheck, FiCalendar } from "react-icons/fi";
import MonthPicker from "../../../components/MonthPicker";
import XmlDropzone from "../components/XmlDropzone";

/**
 * Modal "Novo relatório" da aba Revisor SPED's — mesmo mecanismo de período
 * do modal "Filtrar cálculos" (MonthPicker mês/ano) e, embaixo, a dropzone
 * para subir os XMLs que darão origem ao cálculo (mock).
 */
export default function NovoRelatorioModal({ isOpen, onClose, onCriar }) {
  const [competencia, setCompetencia] = useState(null);
  const [xmls, setXmls] = useState([]);

  if (!isOpen) return null;

  const criar = () => {
    onCriar({ competencia, xmls });
    setCompetencia(null);
    setXmls([]);
    onClose();
  };

  const fechar = () => {
    setCompetencia(null);
    setXmls([]);
    onClose();
  };

  return (
    <div className="lanc-modal-overlay" onClick={fechar}>
      <div className="lanc-modal novo-rel-modal" onClick={(e) => e.stopPropagation()}>
        <div className="lanc-modal-head">
          <h3><FiCalendar style={{ color: "#10b981", marginRight: 8 }} />Novo relatório de apuração</h3>
          <button type="button" className="close" onClick={fechar}><FiX /></button>
        </div>

        <div className="lanc-modal-body">
          <div className="lanc-field">
            <span>Período (competência)</span>
            <MonthPicker
              label="Mês/ano"
              mode="start"
              value={competencia}
              onChange={setCompetencia}
            />
          </div>

          <div className="lanc-field" style={{ marginBottom: 0 }}>
            <span>XMLs do período</span>
            <XmlDropzone
              titulo="Arraste os XMLs do mês aqui"
              hint="ou clique para selecionar · saídas, devoluções e entradas com crédito"
              onFilesChange={setXmls}
            />
          </div>
        </div>

        <div className="lanc-modal-foot">
          <button type="button" className="btn-ghost" onClick={fechar}>Cancelar</button>
          <button
            type="button"
            className="btn-primary"
            onClick={criar}
            disabled={!competencia}
          >
            <FiCheck /> Criar relatório{xmls.length > 0 ? ` (${xmls.length} XMLs)` : ""}
          </button>
        </div>
      </div>
    </div>
  );
}
